<app-login-dialog 
    [(visible)]="loginPopupVisibility"
    [isWebView]="isWebView"
    (switchToSignup)="showSignup()"
    (switchToForgotPassword)="showForgotPassword()">
</app-login-dialog>

<app-signup-dialog 
    [(visible)]="signUpPopupVisibility"
    (switchToLogin)="showLogin()"
    (signupSuccess)="showConfirmation($event)">
</app-signup-dialog>

<app-signup-confirmation-dialog 
    [(visible)]="signupDone"
    [userId]="userId">
</app-signup-confirmation-dialog>

<app-forgot-password-dialog 
    [(visible)]="forgotPasswordPopupVisibility"
    (switchToLogin)="showLogin()">
</app-forgot-password-dialog>
